import React, { useEffect, useState } from "react";
import { Box, Chip, CircularProgress, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const getRecords = data => {
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data)) return data;
  return [];
};

const uniqueById = records => {
  const seen = new Set();
  return records.filter(record => {
    if (!record?.id || seen.has(record.id)) return false;
    seen.add(record.id);
    return true;
  });
};

const SearchEntityFilter = ({ type, onFiltered }) => {
  const isCompany = type === "company";
  const [options, setOptions] = useState([]);
  const [selecteds, setSelecteds] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (search.trim().length < 2) {
      setOptions(selecteds);
      setLoading(false);
      return undefined;
    }

    let active = true;
    const timeout = setTimeout(async () => {
      setLoading(true);
      try {
        const params = isCompany
          ? { q: search.trim(), per_page: 20 }
          : { name: search.trim() };
        const { data } = await api.get(
          isCompany ? "/os/clientes" : "/contacts/list",
          { params }
        );

        if (active) {
          setOptions(uniqueById([...selecteds, ...getRecords(data)]));
        }
      } catch (err) {
        if (active) toastError(err);
      } finally {
        if (active) setLoading(false);
      }
    }, 300);

    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, [search, isCompany, selecteds]);

  const getOptionLabel = option => {
    if (!option) return "";
    if (isCompany) {
      const name = option.razao || option.nome || option.fantasia || "Empresa";
      return option.cnpj_cpf ? `${name} - ${option.cnpj_cpf}` : name;
    }
    return option.number ? `${option.name} - ${option.number}` : option.name || "Contato";
  };

  const handleChange = values => {
    setSelecteds(values);
    onFiltered(values.map(value => value.id));
  };

  return (
    <Box style={{ padding: "0px 10px 10px" }}>
      <Autocomplete
        multiple
        size="small"
        options={options}
        value={selecteds}
        loading={loading}
        onChange={(event, values) => handleChange(values)}
        onInputChange={(event, value, reason) => {
          if (reason === "input") setSearch(value);
        }}
        getOptionLabel={getOptionLabel}
        getOptionSelected={(option, value) => option?.id === value?.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              {...getTagProps({ index })}
              key={`${type}-${option.id}`}
              label={getOptionLabel(option)}
              size="small"
              variant="outlined"
            />
          ))
        }
        renderInput={params => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={isCompany ? "Filtrar por Empresa" : "Filtrar por Contato"}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={16} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export const SearchCompanyFilter = props => (
  <SearchEntityFilter {...props} type="company" />
);

export const SearchContactFilter = props => (
  <SearchEntityFilter {...props} type="contact" />
);

export default SearchEntityFilter;
